"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _SearchResult = _interopRequireDefault(require("./SearchResult"));

var _common = require("@insided/shared/utils/common");

var _components = require("@insided/destination/modules/Search/components");

var _classnames = _interopRequireDefault(require("classnames"));

var CommunitySearchResult = function CommunitySearchResult(_ref) {
  var _topic$firstPost, _topic$firstPost$auth, _topic$firstPost2, _topic$firstPost2$aut, _topic$forum, _topic$forum2, _topic$firstPost3;

  var topic = _ref.topic,
      _clickCallback = _ref.clickCallback;

  var isBugContentTypeEnabled = _common.common.isModuleActive('bugContentType');

  var isConversation = topic.type === 'post' && topic.contentType === 'conversation';
  var isIdea = topic.contentType === 'idea';

  var getStatusPill = function getStatusPill() {
    var _topic$ideationStatus;

    if (isIdea && (_topic$ideationStatus = topic.ideationStatus) !== null && _topic$ideationStatus !== void 0 && _topic$ideationStatus.name) {
      return [{
        type: 'pill',
        text: topic.ideationStatus.name,
        style: {
          backgroundColor: topic.ideationStatus.bgColor,
          color: topic.ideationStatus.color
        }
      }];
    }

    if (isConversation && isBugContentTypeEnabled && topic !== null && topic !== void 0 && topic.bugStatus) {
      var bugStatus = topic.bugStatus;
      return [{
        type: 'pill',
        text: bugStatus.name,
        style: {
          backgroundColor: bugStatus.backgroundColor,
          color: bugStatus.textColor
        }
      }];
    }

    return [{
      type: 'pill',
      text: topic.publicLabel || ''
    }];
  };

  return (0, _preact.h)(_SearchResult.default, {
    clickCallback: function clickCallback() {
      return _clickCallback();
    },
    hideCategoryMetadata: isIdea || topic.contentType === 'productUpdate',
    content: topic.firstPost.content || '',
    icon: (0, _preact.h)(_components.SearchResultIcon, {
      contentType: topic.contentType,
      width: 20,
      height: 20
    }),
    title: topic.title,
    url: topic.url,
    postTitleIconClass: (0, _classnames.default)({
      'icon-question icon--auto-width': topic.contentType === 'question',
      'icon--thread-solved': topic.has_answer,
      'icon--question-circle': !topic.has_answer && topic.contentType === 'question'
    }),
    featuredImage: topic.featuredImage,
    featuredImageAltText: topic.featuredImageAltText || topic.title,
    metaItems: [].concat((0, _toConsumableArray2.default)(getStatusPill()), [{
      type: 'text',
      text: ((_topic$firstPost = topic.firstPost) === null || _topic$firstPost === void 0 ? void 0 : (_topic$firstPost$auth = _topic$firstPost.author) === null || _topic$firstPost$auth === void 0 ? void 0 : _topic$firstPost$auth.name) || '',
      href: (_topic$firstPost2 = topic.firstPost) === null || _topic$firstPost2 === void 0 ? void 0 : (_topic$firstPost2$aut = _topic$firstPost2.author) === null || _topic$firstPost2$aut === void 0 ? void 0 : _topic$firstPost2$aut.url
    }, {
      type: 'text',
      text: ((_topic$forum = topic.forum) === null || _topic$forum === void 0 ? void 0 : _topic$forum.title) || '',
      href: (_topic$forum2 = topic.forum) === null || _topic$forum2 === void 0 ? void 0 : _topic$forum2.url
    }, {
      type: 'text',
      text: (_topic$firstPost3 = topic.firstPost) === null || _topic$firstPost3 === void 0 ? void 0 : _topic$firstPost3.relativeCreationDate
    }])
  });
};

var _default = CommunitySearchResult;
exports.default = _default;